export default __webpack_public_path__ + "static/media/party.7d34da93.svg";